
import React from 'react';

export const Hero: React.FC = () => {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Video */}
      <div className="absolute inset-0 w-full h-full">
        <video
          autoPlay
          muted
          loop
          playsInline
          className="w-full h-full object-cover"
        >
          <source src="https://public.readdy.ai/ai/video_res/a1d2da11-8b76-4016-9117-8a9d679fec89.mp4" type="video/mp4" />
        </video>
        {/* Overlay for better text readability */}
        <div className="absolute inset-0 bg-white/80"></div>
      </div>

      <div className="container mx-auto px-4 py-16 sm:py-20 relative z-10 max-w-full overflow-hidden">
        <div className="max-w-4xl w-full">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-800 mb-4 sm:mb-6 leading-tight break-words">
            <span className="text-pink-600">心に寄り添う</span>
            <span className="ml-2">訪問介護サービス</span>
          </h1>
          <p className="text-lg sm:text-xl md:text-2xl lg:text-3xl text-gray-700 mb-6 sm:mb-8 leading-relaxed break-words">
            福島市で地域の皆様に愛される
            質の高い訪問介護を提供いたします
          </p>
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 mb-8 sm:mb-12">
            <a href="#recruitment" className="bg-pink-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-lg sm:text-xl font-semibold hover:bg-pink-700 transition-colors text-center cursor-pointer whitespace-nowrap">
              求人情報を見る
            </a>
            <a href="#contact" className="border-2 border-pink-600 text-pink-600 px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-lg sm:text-xl font-semibold hover:bg-pink-50 transition-colors text-center cursor-pointer whitespace-nowrap">
              お問い合わせ
            </a>
          </div>
          <div className="bg-white/90 backdrop-blur-sm rounded-lg p-4 sm:p-6 inline-block max-w-full w-full sm:w-auto">
            <div className="flex items-start sm:items-center space-x-3 sm:space-x-4 min-w-0">
              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-pink-100 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-map-pin-fill text-pink-600 text-xl sm:text-2xl"></i>
              </div>
              <div className="min-w-0 flex-1">
                <div className="text-base sm:text-lg font-semibold text-gray-800 mb-1">所在地</div>
                <div className="text-sm sm:text-base lg:text-lg text-gray-600 leading-relaxed break-all">
                  福島県福島市野田町7-13-50-2階
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
